import React, { Component } from 'react';
import { connect } from 'react-redux';
import CardEmpty from '../../../Utils/Cards/CardEmpty'
import Header from 'Utils/Grid/Header';
import Grid from '../../../Utils/Grid';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { standardActions } from '../../../Utils/Grid/StandardActions';
import { actions } from '../../../../../redux/modules/clientes';

class ClientesList extends Component {
    componentDidMount() {
        const { listar, page } = this.props;
        listar(page);
    }

    render() {
        const { listar: onPageChange, onSortChange, eliminar } = this.props;
        const { data, loader, page } = this.props;
        return (
            <CardEmpty noShadow>
                <Header to="clientes/crear" textBtn="CREAR CLIENTE" {...this.props}/>
                <Grid
                    hover
                    striped
                    data={data}
                    loading={loader}
                    onPageChange={onPageChange}
                    onSortChange={onSortChange}
                    page={page}
                >
                    <TableHeaderColumn
                        dataField="id"
                        dataAlign="center"
                        dataSort
                        width="10%"
                        dataFormat={standardActions({ editar: 'clientes', eliminar })}
                    />
                    <TableHeaderColumn
                        isKey
                        dataField="nombre"
                        dataSort
                    >
                        NOMBRE
                    </TableHeaderColumn>
                </Grid>
            </CardEmpty>
        )
    }
}

const ms2p = state => {
    return {
        ...state.clientes,
    }
}

const md2p = { ...actions };

export default connect(ms2p, md2p)(ClientesList);
